import { UserRoleType, UserType } from '@/modules/@common/user/types';

import { slice } from '../slices';

const nameSpace = slice.name;

const userDateDefault = {};

export const getUserDataSelector = (state: RootState) => state[nameSpace].userData ?? (userDateDefault as UserType);

const permissionsDefault: string[] = [];

export const getUserPermissionsSelector = (state: RootState) =>
  state[nameSpace].userData?.permissions ?? permissionsDefault;

const roleDefault = {};

export const getUserRoleSelector = (state: RootState) =>
  state[nameSpace].userData?.role ?? (roleDefault as UserRoleType);

export const getUserIdSelector = (state: RootState) => state[nameSpace].userData?.id ?? null;
export const getUserTimezoneSelector = (state: RootState) => state[nameSpace].userData?.timezone;
export const getUserFirstNameSelector = (state: RootState) => state[nameSpace].userData?.firstName ?? 'User';
export const getUserLastNameSelector = (state: RootState) => state[nameSpace].userData?.lastName ?? '';
export const getUserFullNameSelector = (state: RootState) =>
  `${getUserFirstNameSelector(state)} ${getUserLastNameSelector(state)}`;
export const getUserEmailSelector = (state: RootState) => state[nameSpace].userData?.email ?? null;

export const getUserUpdatedTime = (state: RootState) => state[nameSpace].userData?.updateDate ?? null;
export const getUserIabSelector = (state: RootState) => state[nameSpace].iab;
export const getUserVideoLangsSelector = (state: RootState) => state[nameSpace].videoLangs;
export const getUserImpersonatedSelector = (state: RootState) => state[nameSpace].impersonated;

const ownersDefault: string[] = [];

export const getUserContentOwnersSelector = (state: RootState) =>
  state[nameSpace].userData?.contentOwners ?? ownersDefault;

export const getUserAccountSelector = (state: RootState) => state[nameSpace].userData?.account ?? null;
export const getUserAccountIdSelector = (state: RootState) => state[nameSpace].userData?.accountId ?? null;

export const getPublisherIdsSelector = (state: RootState) => state[nameSpace].userData?.publisherIds ?? null;

export const getUserRoleTypeSelector = (state: RootState) => getUserRoleSelector(state)?.type ?? null;

export const getIntercomUserHashSelector = (state: RootState) => state[nameSpace].userData?.intercomUserHash ?? null;

export const userDataForWatch = (state: RootState) => state[nameSpace].userData;
